export enum SipStartInfoKey {
  WeeklyStartsToday = "SipStartInfoWeeklyStartsToday",
  WeeklyNextMonday = "SipStartInfoWeeklyNextMonday",
  MonthlyStartsToday = "SipStartInfoMonthlyStartsToday",
  MonthlyNextFirst = "SipStartInfoMonthlyNextFirst",
}

export interface EasternTimeParts {
  weekday: number;
  day: number;
  month: number;
  year: number;
  hour: number;
  minute: number;
}

export interface SipYmd {
  year: number;
  month: number;
  day: number;
}
